module.exports = __webpack_public_path__ + "img/00-wide.4c9c7b5c.svg";